import app from '../app.first';
import { each, escape } from 'lodash';

app.SelectedSearchCandidates = class extends app.Component {
	onReady () {
		this.fetchContent();
		$(document).on('Recruiter.Search.selectedCandidates.change', () => this.fetchContent());

		this.$el.find('.selected-list').on('click', '.remove', e => this.removeSelected($(e.target).closest('[data-candidate-id]').data('candidateId')));
	}

	async removeSelected(candidateId) {
		let result = await app.ajax(
			`/recruiter/search/select-candidate/${candidateId}.json`,
			{ selected: false }, false
		);

		if (result && !result.selected) {
			this.fetchContent();
			$(`.candidate-data[data-candidate-id="${candidateId}"]`).removeClass('is-selected')
				.find('input.candidate-id').prop('checked', false)
		}
	}

	async fetchContent() {
		let result = await app.ajax('/recruiter/search/get-selected-candidates.json', false, false);

		this.$el.find('.dropdown-button')
			.addClass('have-selected').prop('disabled', false)
			.find('.num-selected').text(result.candidates.length);

		this.$el.find('.selected-list').empty();
		let items = [];
		each(result.candidates, candidate => {
			items.push(`
				<li class="grid-x align-middle" data-candidate-id="${candidate.id}">
					<a class="remove">&times;</a>
					<img src="${escape(candidate.photo_path)}" class="cell shrink"/>
					<span class="cell auto">${escape(candidate.full_name)}</span>
					<a class="cell shrink cv-link" data-open-cv="/users/cv/${candidate.id}.pdf">
						<i class="cv-icon"></i>
					</a>
					<a class="cell shrink" disabled="true">
						<i class="play-icon"></i>
					</a>
				</li>
			`);
		});
		this.$el.find('.selected-list').append(items);
	}
}
